import { useAtomValue } from 'jotai'
import React from 'react'

import { brandGroupIdAtom } from '~/atoms'
import { VStack } from '~/components/elements/VStack'
import { useSurveyQueryAvailableBrandGroups } from '~/hooks/useSurveyQuery'
import { exists } from '~/utils'

import { tabulationQueryDataAtom } from '../atoms'

import { BrandNineSegmentPanel } from './BrandNineSegmentPanel'
import { ClearGroupsButton } from './ClearGroupsButton'

export const BrandNineSegmentPanels = () => {
  const brandGroups = useSurveyQueryAvailableBrandGroups()
  const brandGroupId = useAtomValue(brandGroupIdAtom)

  const tabulationQueryData = useAtomValue(tabulationQueryDataAtom)
  const brands9segs = tabulationQueryData?.brands9segs

  const brands = React.useMemo(
    () =>
      brandGroups.find((brandGroup) => brandGroup.id === brandGroupId)
        ?.brands ?? [],
    [brandGroupId, brandGroups],
  )

  if (!exists(brands9segs)) {
    return null
  }

  return (
    <VStack align="end" inline={true} spacing={1}>
      <ClearGroupsButton />

      <VStack backgroundColor="grayF3" padding={2} spacing={8}>
        {brands.map((brand) => (
          <BrandNineSegmentPanel key={brand.id} brand={brand} />
        ))}
      </VStack>
    </VStack>
  )
}
